import clientAxios from "../config";

/**
 * Lista las plantillas de contrato. No-admin solo ve las activas;
 * admin ve todas.
 */
const getAgreementTemplates = async (token) => clientAxios.get(`/api/agreement-templates`, {
    headers: { Authorization: `Bearer ${token}` },
});

const getAgreementTemplate = async (token, uuid) => clientAxios.get(`/api/agreement-templates/${uuid}`, {
    headers: { Authorization: `Bearer ${token}` },
});

/**
 * Crea una plantilla. Solo admin.
 */
const createAgreementTemplate = async (token, data) => clientAxios.post(`/api/agreement-templates`, data, {
    headers: { Authorization: `Bearer ${token}` },
});

const updateAgreementTemplate = async (token, uuid, data) => clientAxios.put(`/api/agreement-templates/${uuid}`, data, {
    headers: { Authorization: `Bearer ${token}` },
});

const deleteAgreementTemplate = async (token, uuid) => clientAxios.delete(`/api/agreement-templates/${uuid}`, {
    headers: { Authorization: `Bearer ${token}` },
});

export {
    getAgreementTemplates,
    getAgreementTemplate,
    createAgreementTemplate,
    updateAgreementTemplate,
    deleteAgreementTemplate,
};
